// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"a0936c33","687":"138e2a17","794":"80bdf497"}[chunkId] + ".chunk.js";
};